import { UUID } from 'angular2-uuid';

export enum NotifierMessageType {
  Info,
  Success,
  Warning,
  Error,
  Custom
}

export interface NotifierTranslatableMessage {
  key: string
  params: {};
}

export abstract class NotifierMessageBase {
  id: UUID = UUID.UUID();
  type: NotifierMessageType = NotifierMessageType.Custom;

  abstract get title(): NotifierTranslatableMessage;
  abstract get message(): NotifierTranslatableMessage;
  abstract get autoCloseTimeout(): number;

  get mustAutoClose(): boolean {
    return this.autoCloseTimeout > 0;
  }
}

export class NotifierMessage extends NotifierMessageBase {
  body: string;

  constructor() {
    super();
    this.type = NotifierMessageType.Error;
  }

  get message(): NotifierTranslatableMessage {
    return <NotifierTranslatableMessage>{ key: this.body, params: {} };
  }

  get title(): NotifierTranslatableMessage {
    let key = '';

    switch (this.type) {
      case NotifierMessageType.Info:
        key = 'Info';
        break;
      case NotifierMessageType.Success:
        key = 'Exito';
        break;
      case NotifierMessageType.Warning:
        key = 'Alerta';
        break;
      case NotifierMessageType.Error:
        key = 'Error';
    }
    return <NotifierTranslatableMessage>{ key: key, params: {} };
  }

  get autoCloseTimeout(): number {
    if (this.type === NotifierMessageType.Success || this.type === NotifierMessageType.Info) {
      return 2000;
    }

    if (this.type === NotifierMessageType.Warning) {
      return 5000;
    }

    return -1;
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/notifier/notifier.model.ts